export default __webpack_public_path__ + "static/workflow-ship-a6d32a67aa5b347c34a89f850ef625b9.png";